import type {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import type {
	StartAgenticWorkerRunInput,
	StartAgenticWorkerRunMutation,
} from './__generated__/StartAgenticWorkerRunMutation.graphql';
import type {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

const mutation = graphql`
	mutation StartAgenticWorkerRunMutation($input: StartAgenticWorkerRunInput!) {
		startAgenticWorkerRun(input: $input) {
			run {
				id
				scopeKind
				scopeRowType
				scopeRowId
				state
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<StartAgenticWorkerRunInput>,
	onSuccess?: RelayOnCompleted<StartAgenticWorkerRunMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<StartAgenticWorkerRunMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
